import React from "react";
import styles from "./index.module.scss";

const NewFeaturetag = ({ tag = "New" }) => {
  return (
    <div className={styles.container}>
      <div className={styles.tag}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
        >
          <g>
            <path d="m512 256.8-67.2-54.224 43.2-74.96-91.2-7.968-8-87.728L312 68.608 259.2 0l-49.6 70.176-80-41.472-4.8 90.928-89.6 4.784 33.6 86.128L0 252.016l70.4 52.64-35.2 74.96 88 9.568 4.8 89.328 81.6-38.288L264 512l48-71.776 75.2 36.688 6.4-89.328 88-1.6-32-73.376L512 256.8z"></path>
          </g>
        </svg>
        <p>{tag}</p>
      </div>
    </div>
  );
};

export default NewFeaturetag;
